/**
 * Maps internal errors to user-friendly messages while preserving detailed logs
 */

export const getErrorMessage = (error: any): string => {
  // Log detailed error for debugging (only visible in browser console, not to user)
  console.error('Internal error:', error);

  // Return generic user-friendly message
  if (error?.message?.includes('Too many failed attempts')) {
    return 'Too many failed attempts. Please try again later.';
  }
  
  if (error?.message?.includes('PIN') || error?.message?.includes('Incorrect')) {
    return 'Incorrect PIN or unauthorized action.';
  }

  if (error?.message?.includes('permission') || error?.message?.includes('policy')) {
    return 'You do not have permission to perform this action.';
  }

  if (error?.message?.includes('not found')) {
    return 'The requested resource was not found.';
  }

  if (error?.message?.includes('duplicate') || error?.message?.includes('unique')) {
    return 'This record already exists.';
  }

  if (error?.code === 'PGRST116') {
    return 'No data found matching your request.';
  }

  if (error?.message?.includes('Failed to') || error?.message?.includes('failed')) {
    return error.message;
  }

  // Default generic message
  return 'An error occurred. Please try again or contact support if the problem persists.';
};
